import axios from "@/libs/api.request";

export const getUnpack = params => {
  return axios.request({
    url: "/warehouse/b2bUnpack/unpackQuery",
    method: "get",
    params
  });
};
